import {CREATE_TAG_GROUP, GET_TAG_GROUP_ID, UPDATE_TAG_GROUP} from '../actiontypes';
import {API_RESOURCES, createApiCreateAction, createApiReadAction, createApiUpdateAction} from '../../util/api';

export const createTagGroup = (engagementId, payload) => {
	return createApiCreateAction(
		CREATE_TAG_GROUP,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TAGGROUPS]: undefined
		},
		payload,
		undefined,
		{resolve: true}
	);
};

export const updateTagGroup = (engagementId, tagGroupId, payload) => {
	return createApiUpdateAction(
		UPDATE_TAG_GROUP,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TAGGROUPS]: tagGroupId
		},
		payload
	);
};

export const getTagGroupById = (engagementId, tagGroupId) => {
	return createApiReadAction(
		GET_TAG_GROUP_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TAGGROUPS]: tagGroupId
		},
		undefined,
		{resolve: true}
	);
};
